import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstancehe53gw4v5mqu as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from '../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { readText30p9xkeoodw49 as readText } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/FrameCommon.mjs';
import { Plugin_getInstance2t18sf8ddmzc5 as Plugin_getInstance } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/WebSockets.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  coroutineScope39ukucf23mhsm as coroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { headers24pki7ce1busg as headers } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { url1qder21xodqzl as url } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/buildersWithUrl.mjs';
import { webSocketnufamvos0jph as webSocket } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/builders.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.b56_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().n56_1)) {
    tmp = Companion_getInstance().p56_1;
  } else if (tmp0_subject.equals(Companion_getInstance().m56_1)) {
    tmp = Companion_getInstance().o56_1;
  } else if (tmp0_subject.equals(Companion_getInstance().o56_1) || tmp0_subject.equals(Companion_getInstance().p56_1)) {
    tmp = url.b56_1;
  } else {
    throw UnsupportedOperationException().a1('SOCKS is not a supported protocol');
  }
  this_0.l56(tmp);
  var newUrl = this_0.j37();
  launch($this.m6c_1, VOID, VOID, KtorWebSocketEngine$open$slambda($this, newUrl, headers));
  return new (KtorWebSocketEngine$open$4())($this);
}
function *closeReasonOrNull($this, $receiver, $completion) {
  var tmp;
  try {
    tmp = yield* $receiver.n5b().wy($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function *sendFrames($this, session, $completion) {
  while (true) {
    var frame = yield* $this.o6c_1.f1b($completion);
    yield* session.t5b(frame, $completion);
    if (frame instanceof Close()) {
      $this.n6c_1.o1b();
    }
  }
  return Unit_instance;
}
function *receiveFrames($this, incoming, $completion) {
  while (true) {
    var frame = yield* incoming.f1b($completion);
    if (frame instanceof Text()) {
      $this.n6c_1.d1b(readText(frame));
    } else {
      if (frame instanceof Binary()) {
        $this.n6c_1.d1b(decodeToString(frame.i5b_1));
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unknown frame type';
        throw IllegalStateException().o(toString(message));
      }
    }
  }
  return Unit_instance;
}
function KtorWebSocketEngine$_init_$lambda_2axi3y($this$HttpClient) {
  $this$HttpClient.l5h(Plugin_getInstance());
  return Unit_instance;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/sendFrames(this$0, $this_webSocket, $completion);
    return Unit_instance;
  }, 1);
}
function KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    launch($this$coroutineScope, VOID, VOID, KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket));
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/receiveFrames(this$0, $this_webSocket.r5b(), $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var closeReason = yield* /*#__NOINLINE__*/closeReasonOrNull(this$0, $this_webSocket, $completion);
        var tmp_1;
        if (!(closeReason == null)) {
          tmp_1 = ApolloWebSocketClosedException().w4d(closeReason.x5a_1, closeReason.y5a_1, e);
        } else {
          tmp_1 = ApolloNetworkException().e47('Web socket communication error', e);
        }
        var apolloException = tmp_1;
        this$0.n6c_1.m1b(apolloException);
        throw e;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
function KtorWebSocketEngine$open$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$webSocket, $completion) {
    yield* coroutineScope(KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this$webSocket), $completion);
    return Unit_instance;
  }, 1);
}
function KtorWebSocketEngine$open$slambda(this$0, $newUrl, $headers) {
  return constructCallableReference(function *($this$launch, $completion) {
    try {
      var tmp = ($this$webSocket) => {
        headers($this$webSocket, ($this$headers) => {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = $headers.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            $this$headers.y4p(element.x48_1, element.y48_1);
          }
          return Unit_instance;
        });
        url($this$webSocket, $newUrl);
        return Unit_instance;
      };
      yield* webSocket(this$0.l6c_1, tmp, KtorWebSocketEngine$open$slambda$slambda(this$0), $completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this$0.n6c_1.m1b(ApolloNetworkException().e47('Web socket communication error', e));
      } else {
        throw $p;
      }
    }
    finally {
      this$0.n6c_1.m1b(ApolloNetworkException().e47('Web socket communication error', null));
    }
    return Unit_instance;
  }, 1);
}
var KtorWebSocketEngine$open$4Class;
function KtorWebSocketEngine$open$4() {
  if (KtorWebSocketEngine$open$4Class === VOID) {
    class $ {
      constructor(this$0) {
        this.s6c_1 = this$0;
      }
      *v6b($completion) {
        return yield* this.s6c_1.n6c_1.f1b($completion);
      }
      u6b(data) {
        this.s6c_1.o6c_1.d1b(Binary().x5e(true, data.j3v()));
      }
      j69(string) {
        this.s6c_1.o6c_1.d1b(Text().h5f(string));
      }
      l6() {
        this.s6c_1.o6c_1.d1b(Close().r5c(CloseReason().z5a(1000, '')));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    KtorWebSocketEngine$open$4Class = $;
  }
  return KtorWebSocketEngine$open$4Class;
}
var KtorWebSocketEngineClass;
function KtorWebSocketEngine() {
  if (KtorWebSocketEngineClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.p6c(client);
      }
      static p6c(client) {
        var $this = createThis(this);
        $this.l6c_1 = client;
        $this.m6c_1 = CoroutineScope(Dispatchers_getInstance().h13_1.qm(SupervisorJob()));
        $this.n6c_1 = Channel(2147483647);
        $this.o6c_1 = Channel(2147483647);
        return $this;
      }
      static t6c() {
        return this.p6c(HttpClient(KtorWebSocketEngine$_init_$lambda_2axi3y));
      }
      *f6b(url, headers, $completion) {
        return yield* /*#__NOINLINE__*/open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'KtorWebSocketEngine', $.t6c, VOID, VOID, [2, 1]);
    KtorWebSocketEngineClass = $;
  }
  return KtorWebSocketEngineClass;
}
//region block: exports
export {
  KtorWebSocketEngine as KtorWebSocketEngine2cbfnq8i807su,
};
//endregion

//# sourceMappingURL=KtorWebSocketEngine.mjs.map
